/*
 * @Author: Scarlett Xiao
 * @Date: 2022-01-04 10:12:53
 * @LastEditors: lishiqiao
 * @LastEditTime: 2023-09-05 17:12:57
 */
import Vue from 'vue'
import App from './App.vue'
import router from '../../modules/pc/router'
import moment from 'moment'
import {
  Message,
  Table,
  TableColumn,
  Select,
  Option,
  DatePicker,
  Radio,
  MessageBox,
  Loading,
  Input,
  Button,
  Upload,
  Checkbox,
  Pagination,
  Dialog,
  Carousel,
  CarouselItem,
  Dropdown,
  DropdownMenu,
  DropdownItem
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import "../../assets/less/page.less"
// axios 基于 Promise 的 HTTP 请求插件
import axios from '../../axios/index'
// 引入全局表格样式
import "../../assets/less/page.less"
Vue.prototype.$axios = axios
// 全局自定义变量、方法
import $ from '../../utils/methods/methods'
Vue.prototype.$ = $
import Color from '../../utils/methods/handleColor'
Vue.prototype.$color = Color

import store from '../../store/index'
import '../../assets/DINfont/DINfont.less'
Vue
  .use(Table)
  .use(TableColumn)
  .use(Select)
  .use(Select)
  .use(DatePicker)
  .use(Option)
  .use(Loading)
  .use(Radio)
  .use(Input)
  .use(Button)
  .use(Upload)
  .use(Checkbox)
  .use(Pagination)
  .use(Dialog)
  .use(Carousel)
  .use(CarouselItem)
  .use(Dropdown)
  .use(DropdownMenu)
  .use(DropdownItem)

Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$moment = moment;

import * as filters from '../../utils/filters';
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

import watchStorage from '../../utils/watchStorage';
Vue.use(watchStorage);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')